// Blacklisted.js
import React from 'react';
import "./style.scss";

const Blacklisted = () => {
    return (
        <div className="blacklisted">
            <h1>You have been blacklisted.</h1>
            <p>Looks like you violated our Terms of Service. As warned, you had to follow us on Twitter and repost our Tweet before using the free version of our app. If you believe this was a mistake, reach out to us on <a href="#">Discord</a> or <a href="#">Telegram</a>.</p>
        </div>
    );
}

export default Blacklisted;